import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import styled from 'styled-components'
import { Center, Row } from '../../../../style/basic/commonStyle';
import { addTheme } from '../../../../style/addTheme';
import { LOGO_URL } from '../../../../api/config';
import { useDispatch } from 'react-redux';
import { useAdminUser } from '../../../../utils/custom-hooks/common/useAdminUser';
import { apiAdmLogin } from '../../../../api/api_adm_login';
import { setAdminUser } from '../../../../store/common/adminUser';

export default function AdmLoginPage() {
    const navigate = useNavigate();
    const adminUser = useAdminUser();
    const dispatch = useDispatch();
    const [id,setId] = useState('');
    const [pw,setPw] = useState('');
    
    useEffect(()=>{
        if(adminUser.admin_id === 0) return
        navigate('/adm');
    },[adminUser.admin_id])
    
    const loginAction = async(e:any) =>{
        e.preventDefault();
        const res = await apiAdmLogin(id,pw);
        if(res.result){
            dispatch(setAdminUser({
                ...res.data,
            }));
        }else{
            alert(res.error)
        }
    }
    return (
        <Wrap>
            <LoginWrap onSubmit={loginAction}>
                <AdminIconItem>ADMIN</AdminIconItem>
                <Center style={{marginBottom:'60px'}}>
                    <img style={{height:'36px'}} alt='logo' src={LOGO_URL}></img>
                </Center>
                <InputItem>
                    <input placeholder='관리자 아이디' value={id} onChange={(e:any) => setId(e.target.value)} required/>
                </InputItem>
                <InputItem>
                    <input type='password' placeholder='관리자 비밀번호' value={pw} onChange={(e:any) => setPw(e.target.value)} required/>
                </InputItem>
                <BtnWrap type='submit'>로그인</BtnWrap>
            </LoginWrap>
        </Wrap>
    )
}

const Wrap = styled(Center)`
    width: 100%;
    height: 100vh;
`;

const AdminIconItem = styled(Center)`
    background-color: ${addTheme.adminColor};
    color: #fff;
    font-size: 15px;
    padding: 6px 20px;
    border-radius: 30px;
`;

const LoginWrap = styled.form`
    border-radius: 10px;
    width: 100%;
    max-width: 410px;
    padding: 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
`;

const InputItem = styled(Row)`
    &>input{
        border: 1px solid #ddd;
        padding: 20px;
        border-radius: ${addTheme.round}px;
        width: 100%;
        font-size: 18px;
    }
`;

const BtnWrap = styled.button`
    color: #fff;
    background-color: ${addTheme.adminColor};
    width: 100%;
    height: 62px;
    margin-top: 70px;
    border-radius: ${addTheme.round}px;
    font-size: 20px;
`;